import CloseIcon from "@mui/icons-material/Close";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    styled,
    Typography,
} from "@mui/material";
import PropTypes from "prop-types";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialog-paper": {
        width: "767px",
        padding: "24px",
        borderRadius: "10px",
    },
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
        "& li": {
            listStyle: "disc",
        },
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
        justifyContent: "space-between",
    },
}));

const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2, fontSize: "28px !important" }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 32,
                        top: 28,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};


export const VesselDialogType = {
    ERROR_DUPLICATED_IMO_NUMBER: "This IMO number has been added.",
    ERROR_INVALID_IMO_NUMBER: "Invalid IMO Number.",
    ERROR_VESSEL_NOT_FOUND: "Vessel not found.",
    SUCCESS_VESSEL_FOUND: "Vessel found.",
    TOTAL: 6
}

export default function VesselDialog({
    openDialog,
    setOpenDialog,
    vesselDialogMessageType,
}) {


    const handleClose = () => {
        setOpenDialog(false);
    };
    return (
        <>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={openDialog}
            >
                <BootstrapDialogTitle
                    id="customized-dialog-title"
                    variant="h3"
                    onClose={handleClose}
                >
                </BootstrapDialogTitle>
                <DialogContent /*dividers*/>
                    <Typography
                        gutterBottom
                        className="font-normal-mine-shaft-16px"
                    >
                    {vesselDialogMessageType}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <>

                        <Button
                            onClick={handleClose}
                            className="small button-small font-bold-white-16px"
                            sx={{marginLeft: "400px"}}
                        >
                            OK
                        </Button>

                    </>


                </DialogActions>
            </BootstrapDialog>
        </>
    );
}


